import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('multiSelectBatteryField');

    return {
        BATTERIES: t('batteries'),
        BATTERIES_ARE_REQUIRED: t('batteriesAreRequired')
    };
};

export default useTranslation;
